import { render, staticRenderFns } from "./double-modal-type.vue?vue&type=template&id=add4e118&scoped=true&lang=pug&"
import script from "./double-modal-type.vue?vue&type=script&lang=js&"
export * from "./double-modal-type.vue?vue&type=script&lang=js&"
import style0 from "./double-modal-type.vue?vue&type=style&index=0&id=add4e118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add4e118",
  null
  
)

export default component.exports